import messages from '../../messages';

export const ZIPCODE_REGEX = /^\d{5}$/;

const validateZipcode = (value, formatMessage) => {
  let fieldError = '';
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    fieldError = formatMessage(messages['empty.zipcode.field.error']);
  } else if (!ZIPCODE_REGEX.test(trimmedValue)) {
    fieldError = formatMessage(messages['zipcode.validation.message']);
  }

  return fieldError;
};

export default validateZipcode;
